<button class="close modalClose" mat-button (click)="onNoClick()" tabindex="-1">
  X
</button>
<h1 mat-dialog-title></h1>
<div mat-dialog-content>
  <p class="access">
    You do not have access to edit this page.
    <br />
    Please contact your administrator for assistance
  </p>
</div>
<div mat-dialog-actions></div>
